/**
 * Copyright 2020 New Light Technologies, Inc.
 *
 * With Supporting Sponsorship from the Federal Emergency Management Agency (Contract: GSA Stars II GS-06F-0968Z)
 * In accordance with FAR 52.227-14(c)(iii), New Light Technologies, Inc. grants to the Government and others acting on its behalf a paid-up, nonexclusive, irrevocable, worldwide license in such copyrighted computer software and data to reproduce, prepare derivative works, and perform publicly and display publicly (but not to distribute copies to the public) by or on behalf of the Government.
 * Any other use, distribution, reproduction, modification, or publication without the prior express written authorization of New Light Technologies, Inc. is strictly prohibited.
 * All other rights are reserved by their respective copyright holders.
 *
 */
import { CommunicationsLegend } from './CommunicationsLayer';
import { IncidentSection } from '../pages/IncidentPage';
import { NonResidentialLegend } from './NonResidentialLayer';
import { PopulationLegend } from './PopulationLayer';
import { ResidentialLegend } from './ResidentialLayer';
import { DeclarationsLegend } from './DeclarationsLayer';

type Props = {
  sectionId?: IncidentSection;
};

export const IncidentLegend = (props: Props) => {
  switch (props.sectionId) {
    case 'population':
      return <PopulationLegend />;
    case 'residential':
      return <ResidentialLegend />;
    case 'communications':
      return <CommunicationsLegend />;
    case 'nonResidentialStructures':
      return <NonResidentialLegend />;
    case 'declarations':
      return <DeclarationsLegend />;
    default:
      return null;
  }
};
